'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('../styleInject.js');

var css_248z = ".Content-module_content__dii8H{align-self:flex-start;grid-column:span 12}";
var styles = {"content":"Content-module_content__dii8H"};
styleInject["default"](css_248z, '994cbc5a-2f6e-4144-92e4-43753e979ce2');

exports["default"] = styles;
